import { render, staticRenderFns } from "./ModalManageClient.vue?vue&type=template&id=3eed4372"
import script from "./ModalManageClient.vue?vue&type=script&lang=js"
export * from "./ModalManageClient.vue?vue&type=script&lang=js"
import style0 from "./ModalManageClient.vue?vue&type=style&index=0&id=3eed4372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports